
import { useStore } from "@/store";
import { computed, defineComponent } from "vue";
import EngineAnalyticsElement from "@/components/tab/EngineAnalyticsElement.vue";
import { RectSize } from "@/components/primitive/Types";

export default defineComponent({
  name: "EngineAnalytics",
  components: {
    EngineAnalyticsElement,
  },
  props: {
    size: {
      type: RectSize,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const infos = computed(() => store.state.usi);
    const elementHeight = computed(() => {
      const n =
        (store.state.usi.blackPlayer ? 1 : 0) +
        (store.state.usi.whitePlayer ? 1 : 0) +
        (store.state.usi.researcher ? 1 : 0);
      return n !== 0 ? props.size.height / n : 0;
    });
    return {
      infos,
      elementHeight,
    };
  },
});
